import { connect } from 'react-redux'

import { useState, useEffect } from 'react'

function EncLocalState(Component) {
  return connect(
    (state) => state,
    (dispatch) => ({ dispatch }),
    (state, { dispatch }, { mergeState, ...props }) => {
      return {
        ...props,
      }
    },
    {
      areStatePropsEqual: (a, b) => a === b,
    }
  )(function EncComponent(props) {
    const [localValue, updateValue] = useState()
    const [isDirty, setDirty] = useState(false)
    const [isShowFullLabel, showFullLabel] = useState(false)
    const { id, value, setValue } = props
    let onFocus = () => {
      setDirty(false)
    }

    const subscribeFocus = () => {
      const elem = document.querySelector(`[id='${id}'] input`)
      if (elem) {
        elem.addEventListener('focus', onFocus)
      }
    }

    const unsubscribeFocus = () => {
      const elem = document.querySelector(`[id='${id}'] input`)
      if (elem) {
        setDirty(false)
        elem.removeEventListener('focus', onFocus)
      }
    }

    useEffect(() => {
      subscribeFocus()
      return () => {
        unsubscribeFocus()
      }
    }, [])

    useEffect(() => {
      if (localValue !== value && !isDirty) {
        updateValue(value)
      }
    }, [localValue, isDirty])

    let _value = value
    let _setValue = (value) => {
      setDirty(true)
      updateValue(value)
      setValue(id, value)
    }

    const elem = document.querySelector(`[id='${id}'] input:focus`)
    if (elem) {
      _value = localValue
    }

    const toggleFullLabel = () => {
      showFullLabel(!isShowFullLabel)
    }

    return <Component {...props} value={_value} setValue={_setValue} toggleFullLabel={toggleFullLabel} />
  })
}

export default EncLocalState
